import toast from "react-hot-toast";

export const handleMutationError = (err: any): void => {
  toast.error(err?.response?.data?.message);
};
